import { LandingTheme } from '@anm/api/modules/hosting';
import { FC } from 'react';

import ThemeIcon from './ThemeIcon';
import { ButtonIcon, ItemWrapper } from './Wrapper';

type ThemeItemProps = {
  name: LandingTheme;
  playerColor: string;
  isButtonIcon: boolean;
};

const ThemeItem: FC<ThemeItemProps> = ({ name, isButtonIcon, playerColor }) => (
  <ItemWrapper {...{ playerColor }} variant={name}>
    <ThemeIcon {...{ name, isButtonIcon }} />
    {isButtonIcon && <ButtonIcon variant={name} bgColor={playerColor} />}
  </ItemWrapper>
);

export default ThemeItem;
